import * as FullStory from '@fullstory/browser'

import { useAuth } from 'hooks/UseAuth'
import { getLocationUrl } from 'hooks/useHistory'
import { reportError } from 'utils/error'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { checkFeatureFlagUserGroup, USERS } from 'utils/featureFlagUserGroups'
import { REACT_APP_DISABLE_TRACKING } from 'env'

export const useReportBug = () => {
  const auth = useAuth()

  const isAlmanacUser = checkFeatureFlagUserGroup([USERS.withAlmanacEmail], auth?.email)

  if (!REACT_APP_DISABLE_TRACKING && !FullStory.isInitialized() && isAlmanacUser) {
    try {
      FullStory.init({ orgId: (process.env.REACT_APP_FULLSTORY_ORG_ID as string) || '' })
    } catch (e) {
      reportError(e)
    }
  }

  const reportBug = () => {
    try {
      // Passing true causes the resulting URL to link directly to the current moment within the session
      const sessionUrl = FullStory.getCurrentSessionURL(true)
      const description =
        '\n### Steps to reproduce:' +
        '\n### User Identifier:\n' +
        auth?.id +
        '\n### Email or ID:\n' +
        auth?.email +
        '\n### Time of bug:\n' +
        new Date() +
        '\n### URL:\n' +
        getLocationUrl().href +
        '\n### Actual behavior:' +
        '\n### Expected behavior:' +
        '\n### Fullstory link:\n' +
        sessionUrl

      window
        ?.open(
          `http://linear.app/blazeai/team/BLZ/new?description=${encodeURIComponent(
            description,
          )}&labels=Bug,Blaze+Team+Report`,
          '_blank',
        )
        ?.focus()
    } catch (e) {
      showErrorMessageToast('Something went wrong while reporting the bug')
      reportError(e)
    }
  }

  return { reportBug }
}
